jQuery(function ($) {
    let this_page = 1;

    $(".rubric-overview__btn").on("click", function () {
        const $btn = $(this);
        const loader = $(".rubric-overview__loader");

        loader.addClass("active");

        const data = {
            action: "load_more_news",
            query: JSON.stringify($btn.data("param-posts")),
            page: this_page,
            tpl: $btn.data("tpl"),
            nonce: myajax.nonces.load_more_news
        };

        $.ajax({
            url: myajax.url,
            type: "POST",
            data: data,
            success: function (response) {
                loader.removeClass("active");

                if (response.success) {
                    $(".rubric-overview__wrapper").append(response.data.content);
                    this_page++;

                    if (this_page >= $btn.data("max-pages")) {
                        $btn.remove();
                    }
                } else {
                    alert(response.data.message || "Fehler beim Laden von Artikeln.");
                    $btn.remove();
                }
            },
            error: function () {
                loader.removeClass("active");
                alert("Ein Fehler ist aufgetreten.");
            }
        });
    });
});